<template>
	<button type="button" class="nav-cart-thumb" @click="emit('zoom')">
		<v-avatar size="44" rounded="lg" color="white" class="nav-cart-thumb__image">
			<v-img v-if="url" :src="url" alt="" cover />
			<v-icon v-else size="20" color="grey">inventory_2</v-icon>
		</v-avatar>
		<span v-if="quantity !== 'N/A'" class="nav-cart-thumb__quantity" :class="{ 'nav-cart-thumb__quantity--free': free }">{{ quantity }}</span>
	</button>
</template>

<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';
import { loadProductThumb } from '@/iframe/legacyNavActions';

const props = defineProps({
	uid: { type: String, default: null },
	process: { type: Number, default: 0 },
	quantity: { type: String, default: '' },
	free: { type: Boolean, default: false },
});
const emit = defineEmits(['zoom']);

const url = ref(null);
let token = 0;

const release = () => {
	if (url.value?.startsWith('blob:')) URL.revokeObjectURL(url.value);
	url.value = null;
};

watch(
	() => [props.uid, props.process],
	async ([uid, process]) => {
		const current = ++token;
		const next = await loadProductThumb(uid, process);
		if (current !== token) {
			if (next?.startsWith('blob:')) URL.revokeObjectURL(next);
			return;
		}
		release();
		url.value = next;
	},
	{ immediate: true }
);

onBeforeUnmount(() => {
	token++;
	release();
});
</script>
